// eslint-disable-next-line import/prefer-default-export
export const DataviewFieldDataType = Object.freeze({
    Numeric: 0,
    Date: 1,
});
